<template>
    <el-dialog
        class="create-manual-receiver"
        :visible.sync="show"
        :show-close="false"
        append-to-body
        destroy-on-close
    >
        <manual-receiver-form
            ref="receiverForm"
            :manual-receiver="manualReceiver"
            :entity-uid="entityUid"
            :taker-uid="takerUid"
            @leave-form-view="leaveFormView"
        ></manual-receiver-form>
    </el-dialog>

    </div>
</template>

<script>
import { ManualReceiverForm } from 'gcmcn-common';
export default {

    components: {
        ManualReceiverForm
    },

    props: {
        manualReceivers: {
            type: Array,
            required: true,
        },
        manualReceiver: {
            type: Object,
            default: ()=>{return null;}
        },
        entityUid:{
            type: String,
            default: '',
        },
        takerUid:{
            type: String,
            default: '',
        }
    },

    data (){
        return {
            show: false,
        };
    },

    computed: {

    },

    mounted (){
    },

    methods: {
        open (){
            this.show = true;
        },
        leaveFormView (refresh=false){
            this.$refs.receiverForm.resetData();
            this.$emit('reset-selected-receiver');
            this.show = false;
            if(refresh){
                this.$emit('trigger-refresh');
            }

        },
    },
};
</script>

<style lang="scss">
.create-manual-receiver{
    .gcmcn-card{
        background: linear-gradient(180deg, #111111 12.5%, #222222 100%) !important;
        .el-input-number__decrease,.el-input-number__increase{
            background: #444;
            color: #bbb;
        }
        .gcmcn-form-label{
            font-size: 18px;
            font-family: 'roboto-light';
        }
        .el-form-item__content{
            line-height: 24px;
        }
    }
    .gcmcn-form-label{
        margin-top: 0 !important;
    }
    label{
        color: #bbb;
    }
    .gcmcn-input{
        margin-bottom: 15px;
    }
    .el-dialog__header{
        padding: 0;
    }
    .el-dialog__body{
        min-height: 210px;
        background: linear-gradient(180deg, #111111 12.5%, #222222 100%) !important;
        border-radius: 5px !important;
        text-transform: uppercase;
    }
    .create-manual-receiver-footer{
        display: flex;
        justify-content: space-between;
        button{
            color: #bbb;
        }
        .validate-creation-btn{
            padding: 8px;
            border-radius: 2px;
            font-size: 12px;
            font-family: roboto;
            line-height: 14px;
            color: #444444;
            height: 30px;
            border: none;
            background-color: #bbbbbb;
            &.is-disabled{
                color: #222222;
                background-color: #333333;
            }
        }

    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Settings/modal-create-manual-receiver.vue